import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("导出");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("   总金额: ");

const _hoisted_5 = {
  style: {
    "color": "red"
  }
};
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { dateFormat, getVexTableProps } from '@/config';
import { getSalesmanOrderSummaryList, exportForAsync, getSalemanSupplier } from '@/request';
import { exportSalesmanOrderSummaryList } from '@/request/api';
export default {
  name: 'SalesmanOrderSummary',

  setup(__props) {
    const store = useStore();
    store.dispatch('getBranchList');
    const branchSelectList = computed(() => store.state.branchList);
    const supplierList = ref([]);
    const form = ref({
      supplierName: '',
      linkMan: '',
      startTime: '',
      endTime: '',
      orderState: '',
      branchId: ''
    });
    const formRef = ref();
    const table = ref();
    const total = ref(0);
    const exportAuth = ref(false);
    let dataTotal = 0;
    getSalemanSupplier().then(data => {
      if (data.success) {
        supplierList.value = data.data;
      }
    });
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'seq',
        width: '50px'
      }, {
        title: '业务员',
        field: 'linkMan',
        width: '150px',
        showOverflow: true
      }, // {
      //   title: '账号',
      //   field: 'loginName',
      //   width: '200px',
      //   showOverflow: true
      // },
      {
        title: '下单客户数',
        field: 'custNum',
        width: '100px',
        showOverflow: true
      }, {
        title: '订单条目数',
        field: 'orderNum',
        width: '100px',
        showOverflow: true
      }, {
        title: '订单金额合计',
        field: 'totalPrice',
        width: '150px',
        showOverflow: true
      }, {
        title: '最后登录时间',
        field: 'lastLoginDate',
        width: '200px',
        showOverflow: true
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getSalesmanOrderSummaryList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              total.value = data.totalPrice;
              dataTotal = data.total;
              exportAuth.value = data.exportAuth;
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function reset() {
      formRef.value.resetFields();
      table.value.commitProxy('reload');
    }

    function exportFile() {
      exportForAsync(_objectSpread(_objectSpread({}, form.value), {}, {
        modularflag: 'salesmanSummary',
        fileName: '业务员销售汇总',
        count: dataTotal,
        methodName: exportSalesmanOrderSummaryList.url
      }));
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        model: form.value,
        "label-width": "80px",
        ref_key: "formRef",
        ref: formRef
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发货方",
              prop: "branchId"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                filterable: "",
                modelValue: form.value.branchId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.branchId = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(branchSelectList), item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.text,
                    value: item.id,
                    key: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "团队",
              prop: "supplierName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                filterable: "",
                modelValue: form.value.supplierName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.supplierName = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, sup => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: sup.supplier_name,
                    value: sup.supplier_name,
                    key: sup.supplier_id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "开始时间",
              prop: "startTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.startTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "开始时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "结束时间",
              prop: "endTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.endTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "结束时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "订单状态",
              prop: "orderState"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.orderState,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.orderState = $event),
                placeholder: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "订单已出库",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "其他",
                  value: "2"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "业务员",
              prop: "linkMan"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkMan,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.linkMan = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[6] || (_cache[6] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        tools: _withCtx(() => [exportAuth.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: exportFile,
          icon: "Download"
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : _createCommentVNode("", true), _hoisted_4, _createElementVNode("b", _hoisted_5, _toDisplayString(total.value) + " 元", 1)]),
        _: 1
      }, 16)]);
    };
  }

};